import { render, staticRenderFns } from "./ResultNotice.vue?vue&type=template&id=d9be9836"
import script from "./ResultNotice.vue?vue&type=script&lang=js"
export * from "./ResultNotice.vue?vue&type=script&lang=js"
import style0 from "./ResultNotice.vue?vue&type=style&index=0&id=d9be9836&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports